module.exports = __webpack_public_path__ + "65ed5dd0ce4641ebcd531484cfc987c4.png";